const KEY = 'drv:recent-searches';
const LIMIT = 5;

function read() {
  try {
    const terms = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(terms) ? terms : [];
  } catch {
    return [];
  }
}

function write(terms) {
  try {
    localStorage.setItem(KEY, JSON.stringify(terms));
  } catch {}
}

function remember(term) {
  term = (term || '').trim();
  if (term.length < 2) return;
  write([term, ...read().filter((t) => t.toLowerCase() !== term.toLowerCase())].slice(0, LIMIT));
}

function forget(term) {
  write(read().filter((t) => t !== term));
}

function quickView() {
  return window.Rebuy?.SmartSearch?.quickView?.view;
}

class DrvRecentSearches extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('[data-list]');
    this.removeLabel = this.dataset.removeLabel || 'Remove __TERM__';
    this.addEventListener('click', (event) => event.stopPropagation());
    this.render();
  }

  render(focusIndex) {
    const terms = read();
    this.hidden = terms.length === 0;
    this.list.replaceChildren(...terms.map((term, index) => this.pill(term, index)));

    if (focusIndex === undefined) return;
    const removes = this.list.querySelectorAll('.drv-recent__remove');
    const next = removes[Math.min(focusIndex, removes.length - 1)];
    (next || document.getElementById('searchInput'))?.focus();
  }

  pill(term, index) {
    const item = document.createElement('li');
    item.className = 'drv-recent__pill';

    const run = document.createElement('button');
    run.type = 'button';
    run.className = 'drv-recent__term';
    run.textContent = term;
    run.addEventListener('click', () => this.run(term));

    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'drv-recent__remove';
    remove.setAttribute('aria-label', this.removeLabel.replace('__TERM__', term));
    remove.textContent = '×';
    remove.addEventListener('click', () => {
      forget(term);
      this.render(index);
    });

    item.append(run, remove);
    return item;
  }

  run(term) {
    remember(term);
    const view = quickView();
    if (view) view.search(term);
    else window.location.href = `${window.Shopify?.routes?.root || '/'}search?q=${encodeURIComponent(term)}`;
  }
}

if (!customElements.get('drv-recent-searches')) {
  customElements.define('drv-recent-searches', DrvRecentSearches);
}

document.addEventListener(
  'keydown',
  (event) => {
    const input = event.target;
    if (event.key !== 'Enter' || !(input instanceof HTMLInputElement)) return;
    if (!input.matches('#rebuy-quick-view-dropdown-search #searchInput')) return;
    const view = quickView();
    if (view && !view.quickViewSearchLoading && view.products?.length === 0 && view.collections?.length === 0) return;
    remember(input.value);
  },
  true
);

document.addEventListener(
  'click',
  (event) => {
    if (!(event.target instanceof Element)) return;
    const chip = event.target.closest(
      '#rebuy-quick-view-dropdown-search .rebuy-quick-view__search-term-section-list-term, #rebuy-quick-view-dropdown-search .rebuy-quick-view-dropdown__search-term'
    );
    if (chip) remember(chip.textContent);
  },
  true
);

document.addEventListener('rebuy:smartsearch.quickview.view', () => remember(quickView()?.searchTerm));

document.addEventListener(
  'click',
  (event) => {
    const input = document.querySelector('#rebuy-quick-view-dropdown-search #searchInput');
    if (!(input instanceof HTMLInputElement) || document.activeElement !== input) return;
    const panel = document.getElementById('rebuy-quick-view-dropdown-search');
    if (event.target instanceof Node && panel?.contains(event.target)) return;
    input.blur();
  },
  true
);

function searchPanel() {
  return document.querySelector('#rebuy-quick-view-dropdown-search .rebuy-quick-view-dropdown__container');
}

if (window.visualViewport) {
  const viewport = window.visualViewport;
  const fitKeyboard = () => {
    const keyboard = Math.max(0, Math.round(window.innerHeight - viewport.height - viewport.offsetTop));
    searchPanel()?.style.setProperty('--drv-qv-kb', `${keyboard}px`);
  };
  viewport.addEventListener('resize', fitKeyboard);
  viewport.addEventListener('scroll', fitKeyboard);
}

document.addEventListener(
  'touchmove',
  (event) => {
    const input = document.querySelector('#rebuy-quick-view-dropdown-search #searchInput');
    if (!(input instanceof HTMLInputElement) || document.activeElement !== input) return;
    if (!(event.target instanceof Node) || input.contains(event.target)) return;
    if (searchPanel()?.contains(event.target)) input.blur();
  },
  { capture: true, passive: true }
);
